/** Food cost report labels (FR / AR) — Phase 5 */
export const foodCostReportFr = {
  title: 'Coût food (recettes)',
  subtitle:
    'COGS réel (checkout FIFO + retraits cuisine extra) vs théorique des recettes. Boissons stock et plats se distinguent pour le % théorique.',
  periodMonth: 'Mois en cours',
  period3m: '3 mois calendaires',
  revenue: 'CA ticket (tous)',
  revenueDishes: 'CA plats',
  revenueDirectStock: 'CA stock direct',
  actualCogs: 'COGS réel (ventes)',
  cuisineCost: 'Retraits cuisine (extra)',
  actualTotal: 'COGS réel total',
  theoretical: 'COGS théorique (recettes plats)',
  variance: 'Écart réel − théorique',
  actualPct: 'Food cost réel % (ticket)',
  theoreticalPct: 'Food cost théorique % (plats)',
  mixedSales: 'Ventes mixtes (plat + stock)',
  portions: 'Portions vendues',
  salesCount: 'Ventes',
  missingCogs: 'Ventes sans inventoryCost',
  dishTableTitle: 'Par plat',
  colDish: 'Plat',
  colPortions: 'Portions',
  colRevenue: 'CA',
  colTheoCost: 'Coût théorique',
  colTheoPct: 'FC %',
  colRecipe: 'Recette',
  colPerPortion: 'Coût / portion',
  noRecipe: 'Sans recette active',
  empty:
    'Aucune vente restaurant sur la période. Vendez des plats avec recettes actives pour peupler ce rapport.',
  restaurantOnly: 'Ce rapport est réservé aux restaurants.',
  noteActual:
    'COGS réel = FIFO checkout (plats + boissons stock) + retraits cuisine extra. % réel sur le CA ticket complet.',
  noteTheoretical:
    'Théorique = explosion recettes plats × prix lots (pas les boissons sellOnPos). % théorique sur le CA plats uniquement.',
  noteMixed:
    'Vente mixte : l’écart réel − théorique peut inclure le coût FIFO des boissons (non couvert par les recettes).',
  exportTitle: 'Coût food — recettes'
};

export const foodCostReportAr = {
  title: 'تكلفة الطعام (الوصفات)',
  subtitle:
    'التكلفة الفعلية (FIFO عند البيع + سحب مطبخ إضافي) مقابل النظرية للوصفات. تُفصل المشروبات عن الأطباق في النسبة النظرية.',
  periodMonth: 'الشهر الحالي',
  period3m: '3 أشهر تقويمية',
  revenue: 'رقم الأعمال (التذكرة كاملة)',
  revenueDishes: 'مبيعات الأطباق',
  revenueDirectStock: 'مبيعات مخزون مباشر',
  actualCogs: 'تكلفة فعلية (مبيعات)',
  cuisineCost: 'سحوبات المطبخ (إضافية)',
  actualTotal: 'إجمالي التكلفة الفعلية',
  theoretical: 'تكلفة نظرية (وصفات الأطباق)',
  variance: 'الفرق: فعلي − نظري',
  actualPct: 'نسبة التكلفة الفعلية % (تذكرة)',
  theoreticalPct: 'نسبة التكلفة النظرية % (أطباق)',
  mixedSales: 'مبيعات مختلطة (طبق + مخزون)',
  portions: 'حصص مباعة',
  salesCount: 'مبيعات',
  missingCogs: 'مبيعات بلا inventoryCost',
  dishTableTitle: 'حسب الطبق',
  colDish: 'الطبق',
  colPortions: 'الحصص',
  colRevenue: 'المبيعات',
  colTheoCost: 'تكلفة نظرية',
  colTheoPct: 'ن %',
  colRecipe: 'الوصفة',
  colPerPortion: 'تكلفة / حصة',
  noRecipe: 'بلا وصفة نشطة',
  empty:
    'لا مبيعات مطعم في الفترة. بِع أطباقًا بوصفات نشطة لملء هذا التقرير.',
  restaurantOnly: 'هذا التقرير مخصص للمطاعم.',
  noteActual:
    'التكلفة الفعلية = FIFO عند البيع (أطباق + مشروبات stock) + سحب مطبخ إضافي. النسبة الفعلية على كامل التذكرة.',
  noteTheoretical:
    'النظري = تفجير وصفات الأطباق × أسعار اللوطات. النسبة النظرية على مبيعات الأطباق فقط.',
  noteMixed:
    'بيع مختلط: الفرق فعلي − نظري قد يشمل تكلفة FIFO للمشروبات (غير مغطاة بالوصفات).',
  exportTitle: 'تكلفة الطعام — الوصفات'
};
